var $ = require('jquery');
var addCommas = require('./add-commas');

function pluralize(quantity, opts) {
    /* jshint validthis:true */
    opts = $.extend({ singular: this, plural: this + 's', showCount: false, round: true }, opts || {});
    if (opts.round) {
        quantity = Math.round(quantity);
    }
    return (opts.showCount ? addCommas(quantity + '') + ' ' : '') + (quantity === 1 ? opts.singular : opts.plural);
}

module.exports = function (string, quantity, opts) {
    return pluralize.call(string, quantity, opts);
};
